// function
import * as calculator from './func/calculator';
import * as helper from './func/helper';
import * as validate from './func/validate';
import * as schema from './func/schema';
import * as format from './func/format';
import * as contants from './func/contants';

// types
import type {
  RadixPointType,
  NumberConvertOptions,
  ToRoundProps,
  DocumentWithFullscreen,
  HtmlElementWithFullscreen,
  Response,
  SocketChannel,
  Columns,
} from './types/common.d';
import type {
  OrderSide,
  PositionSide,
  Instruments,
  Symbols,
  OrderUnitType,
  TriggerPriceType,
  OrderType,
  Position,
  Ticker,
  Order,
  TpslOrder,
  MarginMode,
  MarginMode_lower,
  LeverageInfo,
  TriggerOrder,
  TrailingStopOrders,
  SymbolsBySpot,
  Fiat,
  Rates,
  ShareListResponse,
  TypesTrailingStopHistory,
  LiquidationType,
  TradeSettings,
  PositionMode,
  TradeMode,
  ActionType,
  PositionTpSl,
  PositionTrailingStop,
  orderParamsState,
  CopyTradingPositions,
  CloseAllResponse,
  PositionHistoryType,
} from './types/trade.d';
import type { BatchCancelOrderRequest } from './types/api.d';
import type { ShareConfirmParams } from './types/pnl.d';
import type {
  UnionHistoryOrders,
  UnionTriggerHistoryOrders,
  BotSelect,
  TradingBotsType,
  SignalBots,
  TwapBots,
  TwapBotsHistory,
  TwapDetail,
} from './types/union.d';

// hooks
import useVerify from './hooks/useVerify';
import useSaveReferralCode from './hooks/useSaveReferralCode';
import useCurrentLocale from './hooks/useCurrentLocale';
import useLogCustomize from './hooks/useLogCustomize';
import useOrderUnitInfo from './hooks/useOrderUnitInfo';
import type { OrderUnitInfoParams } from './hooks/useOrderUnitInfo';
import useTickerLastPrice from './hooks/useTickerLastPrice';
import useTickerMarkPrice from './hooks/useTickerMarkPrice';
import useBadgeColor from './hooks/useBadgeColor';
import useUnit from './hooks/useUnit';
import useCalculationWidget from './hooks/useCalculationWidget';
import useCopyToClipboard from './hooks/useCopyToClipboard';
import type { TPSLOptions } from './hooks/useCalculationWidget';
import { useConvertQuantity } from './hooks/useConvertQuantity';
import useAlign from './hooks/useAlign';

// storages
import * as tpslStorage from './storages/tpslStorage';

//storage
import ClientStorage from './func/clientStorage';

//mapSymbols
import * as mapSymbolsFunc from './func/mapSymbols';

//enum
import {
  TypesCategory,
  ReverseSide,
  AlgoOrderType,
  botState,
  BadgeBot,
  SignalBotState,
  AlgoOrderState,
  TwapState,
  BadgeTwapState,
  CancelSource,
  TwapOrderDetailStatus,
  PositionTypeState,
} from './enum';

// config
import { defaultPositionsColumns } from './config';

export { mapSymbolsFunc };

export {
  calculator,
  helper,
  validate,
  schema,
  format,
  contants,
  useVerify,
  useSaveReferralCode,
  useCurrentLocale,
  useLogCustomize,
  useOrderUnitInfo,
  useTickerLastPrice,
  useTickerMarkPrice,
  useBadgeColor,
  useUnit,
  useConvertQuantity,
  useAlign,
  ClientStorage,
  OrderUnitInfoParams,
  useCalculationWidget,
  useCopyToClipboard,
  TPSLOptions,
  tpslStorage,
  Response,
  BotSelect,
  CancelSource,
  SignalBots,
  TwapBots,
  TradingBotsType,
  TwapBotsHistory,
  TwapDetail,
  SymbolsBySpot as TypesSpotSymbols,
  RadixPointType as TypesRadixPointType,
  NumberConvertOptions as TypesNumberConvertOptions,
  ToRoundProps as TypesToRoundProps,
  DocumentWithFullscreen as TypesDocumentWithFullscreen,
  HtmlElementWithFullscreen as TypesHtmlElementWithFullscreen,
  OrderSide as TypesOrderSide,
  PositionSide as TypesPositionSide,
  Instruments as TypesInstruments,
  Symbols as TypesSymbols,
  OrderUnitType as TypesOrderUnitType,
  TriggerPriceType as TypesTriggerPriceType,
  OrderType as TypesOrderType,
  Position as TypesPosition,
  Ticker as TypesTicker,
  Order as TypesOrder,
  TpslOrder as TypesTpslOrder,
  MarginMode as TypesMarginMode,
  MarginMode_lower as TypesMarginMode_lower,
  LeverageInfo as TypesLeverageInfo,
  TriggerOrder as TypesTriggerOrder,
  TrailingStopOrders as TypesTrailingStopOrders,
  TypesTrailingStopHistory,
  Fiat as TypesFiat,
  Rates as TypesRates,
  BatchCancelOrderRequest as TypesBatchCancelOrderRequest,
  ShareConfirmParams,
  ShareListResponse,
  UnionHistoryOrders,
  UnionTriggerHistoryOrders,
  LiquidationType,
  TradeSettings as TypesTradeSettings,
  SocketChannel as TypesSocketChannel,
  PositionMode as TypesPositionMode,
  TradeMode as TypesTradeMode,
  ActionType as TypesActionType,
  Columns as TypesColumns,
  PositionTpSl as TypesPositionTpSl,
  PositionTrailingStop as TypesPositionTrailingStop,
  orderParamsState as TypesOrderParamsState,
  CopyTradingPositions as TypesCopyTradingPositions,
  CloseAllResponse as TypesCloseAllResponse,
  PositionHistoryType as TypesPositionHistoryType,
  PositionTypeState as TypesPositionTypeState,
};

//enum
export {
  TypesCategory,
  ReverseSide as TypesReverseSide,
  AlgoOrderType as TypesAlgoOrderType,
  botState,
  BadgeBot,
  SignalBotState,
  AlgoOrderState,
  TwapState,
  BadgeTwapState,
  TwapOrderDetailStatus,
};

//config
export { defaultPositionsColumns };
